// removed by extract-text-webpack-plugin
module.exports = {"companyTable":"company_companyTable_3TDz8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/company.scss
// module id = 1557
// module chunks = 0